import { FETCH_RESOURCES_ASYNC } from './constants'

export const fetchResources = () => ({ type: FETCH_RESOURCES_ASYNC.INITIATE })
export const fetchResourcesSuccess = (data) => ({
  type: FETCH_RESOURCES_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchResourcesError = (error) => ({
  type: FETCH_RESOURCES_ASYNC.ERROR,
  error,
})
export const fetchResourcesCancel = () => ({
  type: FETCH_RESOURCES_ASYNC.CANCEL,
})

export default {
  // to props
  fetchResources,
  fetchResourcesCancel,
}
